import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, DoorClosed, DoorOpen, Target } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-32 bg-zinc-950 relative overflow-hidden" data-id="element-82">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-teal-500 to-transparent opacity-50" data-id="element-83" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-teal-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-84" />

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10" data-id="element-85">
        <div className="text-center mb-16" data-id="element-86">
          <span className="text-teal-500 font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-87">
            The Unique Mechanism
          </span>
          <h2 className="font-display text-5xl md:text-6xl text-zinc-50 mb-8" data-id="element-88">
            THE ANTI-RESUME STRATEGY
          </h2>
          <p className="text-xl text-zinc-300 max-w-3xl mx-auto leading-relaxed" data-id="element-89">
            Instead of asking for a job, you identify a "Bleeding Neck" problem
            within a company and offer a fixed-term, high-ticket solution. We
            bypass the front door of HR and walk through the side door of the
            C-Suite.{' '}
            <strong className="text-white" data-id="element-90">
              You stop being a "candidate" and start being an "intervention."
            </strong>
          </p>
        </div>

        {/* Visual Diagram */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-16 bg-zinc-900/80 border border-zinc-800 rounded-xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-91">
          <div className="flex flex-col items-center text-center flex-1" data-id="element-92">
            <div className="w-20 h-20 rounded-full bg-red-500/10 flex items-center justify-center mb-4 border border-red-500/20" data-id="element-93">
              <DoorClosed className="w-10 h-10 text-red-500" data-id="element-94" />
            </div>
            <h3 className="font-display text-2xl text-zinc-400 mb-2" data-id="element-95">
              THE OLD WAY
            </h3>
            <p className="text-zinc-500 text-sm" data-id="element-96">
              HR Front Door (ATS Black Hole)
            </p>
          </div>

          <div className="hidden md:flex flex-col items-center justify-center text-zinc-600" data-id="element-97">
            <ArrowRight className="w-8 h-8" data-id="element-98" />
            <span className="text-xs font-bold uppercase mt-2 tracking-widest" data-id="element-99">
              Pivot
            </span>
          </div>

          <div className="flex flex-col items-center text-center flex-1" data-id="element-100">
            <div className="w-20 h-20 rounded-full bg-teal-500/10 flex items-center justify-center mb-4 border border-teal-500/20 relative" data-id="element-101">
              <div className="absolute inset-0 rounded-full bg-teal-500/20 animate-ping" data-id="element-102" />
              <DoorOpen className="w-10 h-10 text-teal-400 relative z-10" data-id="element-103" />
            </div>
            <h3 className="font-display text-2xl text-teal-400 mb-2" data-id="element-104">
              THE NEW WAY
            </h3>
            <p className="text-zinc-300 text-sm font-medium" data-id="element-105">
              C-Suite Side Door (Direct Offer)
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}